import { supabase } from "@/integrations/supabase/client";
import type { CharacterWithTags } from "@/types/character";
import { useQuery } from "@tanstack/react-query";

export const useCharacter = (characterId: string) => {
  return useQuery({
    queryKey: ["character", characterId],
    queryFn: async (): Promise<CharacterWithTags | null> => {
      const { data: characterData, error: characterError } = await supabase
        .from("characters")
        .select(
          `id, name, title, short_description, avatar_url, rating, created_at, updated_at, first_message_helper_text, tags (id, name)`
        )
        .eq("id", characterId)
        .single();

      if (characterError) {
        console.error("Error fetching character:", characterError);
        throw characterError;
      }

      if (!characterData) {
        return null;
      }

      // Transform the data to match our expected format
      const characterWithTags: CharacterWithTags = {
        id: characterData.id,
        name: characterData.name,
        title: characterData.title,
        short_description: characterData.short_description,
        avatar_url: characterData.avatar_url,
        rating: characterData.rating,
        created_at: characterData.created_at,
        updated_at: characterData.updated_at,
        first_message_helper_text: characterData.first_message_helper_text,
        tags: characterData.tags || [],
      };

      return characterWithTags;
    },
    enabled: !!characterId,
  });
};
